<homeleite-layout-base
    [fillPrimary]="fillPrimary"
    [pageTitle]="pageTitle"
    [showSearch]="showSearch"
    [searchPlaceholder]="searchPlaceholder"
    [showMenu]="showMenu"
    [showBack]="showBack"
    [showActionBar]="showActionBar"
    [showLogout]="showLogout"
    [homePath]="homePath"
    [user]="user$"
    [onSideBackClick]="onSideBackClickFn"
    (searchChange)="searchChange.emit($event)"
    (backClick)="onBackClick($event)"
    (logoutClick)="onLogout()"
>
    <ng-container menu>
        @if (submenu) {
        <app-menu
            animate.enter="menu-enter"
            animate.leave="menu-leave"
            [entries]="submenu.childs"
            (menuItemClicked)="layoutBase.closeMenu()"
        >
            <a before mat-list-item (click)="onSideBackClickFn()">
                <mat-icon matListItemIcon>arrow_back</mat-icon>
                <span matListItemTitle>{{ submenu.name }}</span>
            </a>
        </app-menu>
        } @else {
        <app-menu
            animate.enter="menu-enter"
            animate.leave="menu-leave"
            [entries]="mainMenu"
            (submenuClicked)="onSubmenuClick($event)"
            (menuItemClicked)="layoutBase.closeMenu()"
        >
            <a
                before
                mat-list-item
                [routerLink]="homePath"
                routerLinkActive="active-menu-item"
                (click)="layoutBase.closeMenu()"
            >
                <mat-icon matListItemIcon>home</mat-icon>
                <span matListItemTitle>Início</span>
            </a>
            <a after mat-list-item (click)="onLogout()" style="cursor: pointer">
                <mat-icon matListItemIcon>exit_to_app</mat-icon>
                <span matListItemTitle>Sair</span>
            </a>
        </app-menu>
        }
    </ng-container>

    <ng-container actions>
        <app-integration-alerts-bell></app-integration-alerts-bell>
        <ng-content select="[actions]"></ng-content>
    </ng-container>

    <ng-content></ng-content>
</homeleite-layout-base>
